var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11317_197)",
    filter: "url(#filter0_d_11317_197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9222 10.2516C22.7568 10.011 18.7825 4.375 12.5 4.375C7.10898 4.375 2.30515 9.9786 2.10302 10.2175C1.96566 10.3802 1.96566 10.6191 2.10302 10.7827C2.30515 11.0216 7.10898 16.6252 12.5 16.6252C17.8909 16.6252 22.6947 11.0216 22.8968 10.7827C23.0237 10.6322 23.0351 10.4144 22.9222 10.2516ZM12.5 15.7502C8.17827 15.7502 4.06918 11.6289 3.02531 10.5001C4.06746 9.3705 8.17216 5.25004 12.5 5.25004C17.5566 5.25004 21.1258 9.36525 21.9974 10.4765C20.9911 11.5694 16.8584 15.7502 12.5 15.7502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7C10.5698 7 9 8.56977 9 10.5C9 12.4303 10.5698 14.0001 12.5 14.0001C14.4303 14.0001 16.0001 12.4303 16.0001 10.5C16.0001 8.56977 14.4303 7 12.5 7ZM12.5 13.1251C11.0528 13.1251 9.875 11.9473 9.875 10.5001C9.875 9.05282 11.0528 7.87504 12.5 7.87504C13.9473 7.87504 15.1251 9.05282 15.1251 10.5001C15.1251 11.9473 13.9473 13.1251 12.5 13.1251Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11317_197",
    x: 0,
    y: -1,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11317_197"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11317_197",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11317_197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.17890f9d0b0866f89ddb773d9f6a3639.svg";
export { ForwardRef as ReactComponent };